import {
  Alert,
  Stack,
  useWizardPage,
  Wizard
} from '@efast_public/fjd-component-library';
import React, { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { WeiterleitungsWizardState } from '../Wizard.types';
import { SyncResultDto } from '../../../api/hooks/useSyncResult';

function Summary(): ReactElement {
  const { t } = useTranslation();

  const { wizardState } = useWizardPage({
    isFormValid: true,
    headline: (state) =>
      `Schritt ${state.currentPageIndex + 1} von ${state.pagesLength}`
  });
  const state = wizardState.state as WeiterleitungsWizardState | undefined;
  const syncResult: SyncResultDto | undefined = state?.syncResult;

  return (
    <Wizard.Page>
      <Stack direction="column" spacing="xs">
        <Alert
          message={t('receiverSettingsWizard.summary.fitCoSuccess')}
          variant="success"
        />
        {syncResult && (
          <Stack direction="column" spacing="xs">
            {syncResult.importedOrgUnitNames.length > 0 && (
              <Alert
                variant="success"
                message={t('receiverSettingsWizard.summary.importedOrgUnits', {
                  names: syncResult.importedOrgUnitNames.join(', '),
                  count: syncResult.importedOrgUnitNames.length
                })}
              />
            )}
            {syncResult.deactivatedOrgUnitNames.length > 0 && (
              <Alert
                variant="warning"
                message={t(
                  'receiverSettingsWizard.summary.deactivatedOrgUnits',
                  {
                    names: syncResult.deactivatedOrgUnitNames.join(', '),
                    count: syncResult.deactivatedOrgUnitNames.length
                  }
                )}
              />
            )}
            {syncResult.deletedOrgUnitNames.length > 0 && (
              <Alert
                variant="warning"
                message={t('receiverSettingsWizard.summary.deletedOrgUnits', {
                  names: syncResult.deletedOrgUnitNames.join(', '),
                  count: syncResult.deletedOrgUnitNames.length
                })}
              />
            )}
            {syncResult.addedPublicServices.length > 0 && (
              <Alert
                variant="success"
                message={t(
                  'receiverSettingsWizard.summary.addedPublicServices',
                  { count: syncResult.addedPublicServices.length }
                )}
              />
            )}
            {syncResult.removedPublicServices.length > 0 && (
              <Alert
                variant="warning"
                message={t(
                  'receiverSettingsWizard.summary.removedPublicServices',
                  { count: syncResult.removedPublicServices.length }
                )}
              />
            )}
            {syncResult.newlyImported.length > 0 && (
              <Alert
                variant="success"
                message={t('receiverSettingsWizard.summary.addedSchemaUris', {
                  total: syncResult.newlyImported.length
                })}
              />
            )}
            {syncResult.syncStatus.some((s) => !s.dataAvailable) && (
              <Alert
                variant="warning"
                message={t('receiverSettingsWizard.summary.updatedSchemaUris', {
                  pending: syncResult.syncStatus.filter((s) => !s.dataAvailable)
                    .length,
                  total: syncResult.syncStatus.length
                })}
              />
            )}
            {syncResult.importedOrgUnitNames.length === 0 &&
              syncResult.deactivatedOrgUnitNames.length === 0 &&
              syncResult.deletedOrgUnitNames.length === 0 &&
              syncResult.addedPublicServices.length === 0 &&
              syncResult.removedPublicServices.length === 0 &&
              syncResult.newlyImported.length === 0 &&
              !syncResult.syncStatus.some((s) => !s.dataAvailable) && (
                <Alert
                  variant="info"
                  message={t('receiverSettingsWizard.summary.noChanges')}
                />
              )}
          </Stack>
        )}
      </Stack>
    </Wizard.Page>
  );
}

export default Summary;
